import DeliveryDate from 'components/DeliveryDate';
import RegionDropDown from 'components/RegionDropDown/RegionDropDown';
import React from 'react';
function TimeAndPlace() {
    return (React.createElement("div", null,
        React.createElement(RegionDropDown, null),
        React.createElement(DeliveryDate, null)));
}
export default TimeAndPlace;
